import { useContext } from 'react';
import HeroSectionLogo from '../../../assets/images/heros/mobile-log-hero.svg';
import { LangContext } from '../../../App';

type MobHeroSectionTwoPropsType = {
    image : string;
    title : string;
    subtitle? : string;
}

const MobHeroSectionTwo = ({ image, title, subtitle } : MobHeroSectionTwoPropsType ) => {
  const { lang } = useContext(LangContext);
  return (
    <header className={`mob-hero-section-tow ${lang ? "rlt" : ""}`} id="header">
        <img src={image} alt="Hero section background" className='background-image' />
        <div className="top-layer">
            <img src={HeroSectionLogo} alt="" aria-hidden="true" />
            <div className="info-box">
                <h1 className="title">{title}</h1>
                <p className="subtitle">{subtitle}</p>
            </div>
        </div>
    </header>
  )
}

export default MobHeroSectionTwo